import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeadphones = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_349_40187)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.08126 22.1562V12.3918C5.08126 12.3918 1.74394 12.3057 1.42098 12.7363C1.01189 13.3069 0.893466 21.1765 1.42098 21.7148C1.94849 22.253 5.08126 22.1669 5.08126 22.1669V22.1562Z",
				fill: "currentColor",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6353 22.1562V12.3918C27.6353 12.3918 30.9726 12.3057 31.2955 12.7363C31.7046 13.3069 31.8231 21.1765 31.2955 21.7148C30.768 22.253 27.6353 22.1669 27.6353 22.1669V22.1562Z",
				fill: "currentColor",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.0813 12.3908C5.0813 12.3908 5.0813 1.07617 16.9449 1.07617C27.6351 1.07617 27.6351 12.3908 27.6351 12.3908",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.2704 22.0039V25.7934L24.5562 29.7874H20.4653",
				stroke: "currentColor",
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.0874 31.5859C20.0803 31.5859 20.8852 30.781 20.8852 29.7881C20.8852 28.7952 20.0803 27.9902 19.0874 27.9902C18.0945 27.9902 17.2896 28.7952 17.2896 29.7881C17.2896 30.781 18.0945 31.5859 19.0874 31.5859Z",
				fill: "currentColor",
				stroke: "currentColor",
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_349_40187",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32.7273,
			height: 32.1244,
			fill: "currentColor"
		})
	}) })]
});
export default SvgHeadphones;
